import React, { useState, useEffect, useCallback } from "react";
// SkilsmisseVejen — Klient Selvbetjeningsportal
// Tilgaas via: /portal?noegle=xxx
// Backend: /api/portal/* (routes/klient-portal.js)
const FASER = [
 { id: 0, navn: "Indgang og Triage", ikon: "LogIn", beskrivelse: "Vi kortlaegger din situation" },
 { id: 1, navn: "Afklaring", ikon: "", beskrivelse: "Vi afklarer juridiske og praktiske forhold" },
 { id: 2, navn: "Aktiv Haandtering", ikon: "", beskrivelse: "Vi arbejder aktivt med din sag" },
 { id: 3, navn: "Stabilisering", ikon: "", beskrivelse: "Vi sikrer din nye hverdag" },
 { id: 4, navn: "Afslutning", ikon: "", beskrivelse: "Din sag afsluttes og du er klar" },
];
const HAENDELSE_IKONER = {
 mail_ind: "", mail_ud: "", opkald: "", moede: "",
 dokument: "", note: "", juridisk: "", oekonomi: "",
 default: "",
};
const T = {
 bg: "#f8f9fa", kort: "#ffffff", primaer: "#2563eb",
 primaer_lys: "#eff6ff", groen: "#16a34a", groen_lys: "#f0fdf4",
 subtil: "#6b7280", tekst: "#111827", kant: "#e5e7eb",
};
function api_portal(sti, metode, data, token) {
 const opts = {
 method: metode || "GET",
 headers: { "Content-Type": "application/json", ...(token ? { Authorization: "Bearer " + token } : {}) },
 credentials: "include",
 };
 if (data) opts.body = JSON.stringify(data);
 return fetch("/api/portal/" + sti, opts).then(r => {
 if (!r.ok) return r.json().catch(() => ({})).then(e => Promise.reject(new Error(e.fejl || `HTTP ${r.status}`)));
 return r.json();
 });
}
function ForloebTrin({ fase }) {
 const aktiv_fase = parseInt(fase) || 0;
 return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: "24px 28px", marginBottom: 20 }}> <div style={{ fontSize: 13, fontWeight: 600, color: T.subtil, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 18 }}>
 Dit forloeb
 </div> <div style={{ display: "flex", alignItems: "flex-start", gap: 0, position: "relative" }}>
 {FASER.map((f, i) => {
 const aktiv = f.id === aktiv_fase;
 const fuldfoert = f.id < aktiv_fase;
 return (
 <div key={f.id} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
 {i < FASER.length - 1 && (
 <div style={{
 position: "absolute", top: 19, left: "50%", width: "100%", height: 3,
 background: fuldfoert ? T.groen : T.kant, zIndex: 0,
 }} />
 )}
 <div style={{
 width: 40, height: 40, borderRadius: "50%",
 border: "3px solid " + (aktiv ? T.primaer : fuldfoert ? T.groen : T.kant),
 background: aktiv ? T.primaer_lys : fuldfoert ? T.groen_lys : "#fff",
 display: "flex", alignItems: "center", justifyContent: "center",
 fontSize: 18, zIndex: 1, position: "relative",
 boxShadow: aktiv ? "0 0 0 4px " + T.primaer_lys : "none",
 }}>
 {fuldfoert ? "" : f.ikon}
 </div> <div style={{ marginTop: 8, fontSize: 11, fontWeight: aktiv ? 700 : 500, color: aktiv ? T.primaer : fuldfoert ? T.groen : T.subtil, textAlign: "center", lineHeight: 1.3 }}>
 {f.navn}
 </div> </div>
 );
 })}
 </div>
 {FASER[aktiv_fase] && (
 <div style={{ marginTop: 20, padding: "12px 16px", background: T.primaer_lys, borderRadius: 10, borderLeft: "4px solid " + T.primaer }}> <div style={{ fontSize: 14, fontWeight: 600, color: T.primaer }}>{FASER[aktiv_fase].navn}</div> <div style={{ fontSize: 13, color: "#1d4ed8", marginTop: 4 }}>{FASER[aktiv_fase].beskrivelse}</div> </div>
 )}
 </div>
 );
}
function SagKort({ sag }) {
 const deadline_dato = sag && sag.naeste_deadline ? new Date(sag.naeste_deadline) : null;
 const dage_til = deadline_dato ? Math.ceil((deadline_dato - new Date()) / 86400000) : null;
 const deadline_farve = dage_til !== null ? (dage_til <= 3 ? "#dc2626" : dage_til <= 14 ? "#d97706" : T.groen) : T.subtil;
 return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: "24px 28px", marginBottom: 20 }}> <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}> <div> <div style={{ fontSize: 22, fontWeight: 700, color: T.tekst }}>Hej, {(sag && sag.fornavn) || ""}!</div> <div style={{ fontSize: 14, color: T.subtil, marginTop: 4 }}>Sagsnummer: <strong>{sag && sag.sagsnummer}</strong></div>
 {sag && sag.sagsbehandler && (
 <div style={{ fontSize: 14, color: T.subtil, marginTop: 2 }}>Sagsbehandler: <strong>{sag.sagsbehandler}</strong></div>
 )}
 </div>
 {deadline_dato && (
 <div style={{ background: deadline_farve + "15", border: "1px solid " + deadline_farve + "40", borderRadius: 12, padding: "12px 18px", textAlign: "right" }}> <div style={{ fontSize: 11, fontWeight: 600, color: deadline_farve, textTransform: "uppercase", letterSpacing: "0.08em" }}>
 {(sag && sag.naeste_deadline_titel) || "Naeste deadline"}
 </div> <div style={{ fontSize: 18, fontWeight: 700, color: deadline_farve, marginTop: 4 }}>
 {deadline_dato.toLocaleDateString("da-DK", { day: "numeric", month: "long" })}
 </div> <div style={{ fontSize: 12, color: deadline_farve, opacity: 0.8 }}>
 {dage_til === 0 ? "I dag" : dage_til < 0 ? (Math.abs(dage_til) + " dage siden") : ("Om " + dage_til + (dage_til === 1 ? " dag" : " dage"))}
 </div> </div>
 )}
 </div> </div>
 );
}
function Tidslinje({ haendelser }) {
 if (!haendelser || !haendelser.length) return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: 28, marginBottom: 20, textAlign: "center", color: T.subtil }}>
 Ingen haendelser endnu.
 </div>
 );
 return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: "24px 28px", marginBottom: 20 }}> <div style={{ fontSize: 13, fontWeight: 600, color: T.subtil, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 18 }}>Aktivitet i din sag</div> <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
 {haendelser.map(function(h, i) {
 const dato = h.begivenhedsdato || h.oprettet_dato;
 const ikon = HAENDELSE_IKONER[h.type] || HAENDELSE_IKONER.default;
 return (
 <div key={h.id} style={{ display: "flex", gap: 16, paddingBottom: i < haendelser.length - 1 ? 20 : 0, position: "relative" }}>
 {i < haendelser.length - 1 && (
 <div style={{ position: "absolute", left: 19, top: 40, bottom: 0, width: 2, background: T.kant }} />
 )}
 <div style={{ width: 40, height: 40, borderRadius: "50%", background: T.primaer_lys, border: "2px solid " + T.kant, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0, zIndex: 1 }}>
 {ikon}
 </div> <div style={{ flex: 1, paddingTop: 8 }}> <div style={{ fontWeight: 600, fontSize: 14, color: T.tekst }}>{h.titel}</div>
 {h.beskrivelse && <div style={{ fontSize: 13, color: T.subtil, marginTop: 4, lineHeight: 1.5 }}>{h.beskrivelse.slice(0, 200)}{h.beskrivelse.length > 200 ? "…" : ""}</div>}
 <div style={{ fontSize: 12, color: T.subtil, marginTop: 6 }}>
 {dato ? new Date(dato).toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" }) : ""}
 {h.forfatter ? " · " + h.forfatter : ""}
 </div> </div> </div>
 );
 })}
 </div> </div>
 );
}
function Dokumenter({ dokumenter }) {
 function fmt_bytes(b) {
 if (b > 1024*1024) return (b/1024/1024).toFixed(1) + " MB";
 if (b > 1024) return (b/1024).toFixed(0) + " KB";
 return b + " B";
 }
 return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: "24px 28px", marginBottom: 20 }}> <div style={{ fontSize: 13, fontWeight: 600, color: T.subtil, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 16 }}>Dokumenter ({(dokumenter && dokumenter.length) || 0})</div>
 {(!dokumenter || !dokumenter.length) ? (
 <div style={{ color: T.subtil, fontSize: 14 }}>Ingen dokumenter endnu.</div>
 ) : (
 <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
 {dokumenter.map(function(d) { return (
 <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 14px", background: T.bg, borderRadius: 10, border: "1px solid " + T.kant }}> <span style={{ fontSize: 24 }}></span> <div style={{ flex: 1 }}> <div style={{ fontWeight: 600, fontSize: 14, color: T.tekst }}>{d.visningsnavn || d.original_navn}</div> <div style={{ fontSize: 12, color: T.subtil }}>
 {d.stoerrelse ? fmt_bytes(d.stoerrelse) : ""}
 {d.uploadet_dato ? " · " + new Date(d.uploadet_dato).toLocaleDateString("da-DK") : ""}
 </div> </div> </div>
 ); })}
 </div>
 )}
 </div>
 );
}
function SendBesked({ token }) {
 const [tekst, setTekst] = useState("");
 const [sender, setSender] = useState(false);
 const [sendt, setSendt] = useState(false);
 async function send() {
 if (!tekst.trim() || sender) return;
 setSender(true);
 try {
 const r = await api_portal("besked", "POST", { tekst: tekst }, token);
 if (r.succes) { setSendt(true); setTekst(""); setTimeout(function() { setSendt(false); }, 5000); }
 } finally { setSender(false); }
 }
 return (
 <div style={{ background: T.kort, border: "1px solid " + T.kant, borderRadius: 16, padding: "24px 28px", marginBottom: 20 }}> <div style={{ fontSize: 13, fontWeight: 600, color: T.subtil, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Send besked til din sagsbehandler</div>
 {sendt && (
 <div style={{ background: T.groen_lys, border: "1px solid #bbf7d0", borderRadius: 10, padding: "12px 16px", marginBottom: 14, color: T.groen, fontWeight: 600, fontSize: 14 }}>
 Besked sendt — din sagsbehandler svarer dig snarest.
 </div>
 )}
 <textarea
 value={tekst}
 onChange={function(e) { setTekst(e.target.value); }}
 placeholder="Skriv din besked her…"
 rows={4}
 style={{ width: "100%", border: "1px solid " + T.kant, borderRadius: 10, padding: "12px 14px", fontSize: 14, fontFamily: "inherit", resize: "vertical", outline: "none", boxSizing: "border-box", color: T.tekst }}
 /> <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}> <button onClick={send} disabled={!tekst.trim() || sender}
 style={{ background: (tekst.trim() && !sender) ? T.primaer : T.kant, color: (tekst.trim() && !sender) ? "#fff" : T.subtil, border: "none", borderRadius: 10, padding: "10px 24px", fontWeight: 700, fontSize: 14, cursor: (tekst.trim() && !sender) ? "pointer" : "not-allowed" }}>
 {sender ? "Sender…" : "Send besked"}
 </button> </div> </div>
 );
}
export default function KlientPortal({ noegle }) {
 const [tilstand, setTilstand] = useState("logger_ind");
 const [fejl, setFejl] = useState(null);
 const [token, setToken] = useState(null);
 const [sag, setSag] = useState(null);
 const [haendelser, setHaendelser] = useState([]);
 const [dokumenter, setDokumenter] = useState([]);
 const [fane, setFane] = useState("overblik");
 const log_ind = useCallback(async function(noegle_val) {
 setTilstand("logger_ind");
 try {
 const r = await api_portal("adgang", "POST", { noegle: noegle_val });
 if (r.fejl || !r.token) {
 setFejl(r.fejl || "Ugyldigt link. Kontakt din sagsbehandler.");
 setTilstand("fejl");
 return;
 }
 setToken(r.token);
 const [sag_r, tids_r, dok_r] = await Promise.all([
 api_portal("sag", "GET", null, r.token),
 api_portal("tidslinje", "GET", null, r.token),
 api_portal("dokumenter", "GET", null, r.token),
 ]);
 setSag(sag_r.sag || null);
 setHaendelser(tids_r.haendelser || []);
 setDokumenter(dok_r.dokumenter || []);
 setTilstand("portal");
 } catch (err) {
 setFejl("Kunne ikke oprette forbindelse. Proev igen.");
 setTilstand("fejl");
 }
 }, []);
 useEffect(function() { if (noegle) log_ind(noegle); }, [noegle, log_ind]);
 if (tilstand === "logger_ind") return (
 <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center" }}> <div style={{ textAlign: "center" }}> <div style={{ fontSize: 40, marginBottom: 16 }}></div> <div style={{ fontSize: 18, fontWeight: 600, color: T.tekst }}>Logger ind…</div> <div style={{ fontSize: 14, color: T.subtil, marginTop: 8 }}>Et oejeblik.</div> </div> </div>
 );
 if (tilstand === "fejl") return (
 <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}> <div style={{ background: T.kort, border: "1px solid #fecaca", borderRadius: 20, padding: 40, maxWidth: 460, width: "100%", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}> <div style={{ fontSize: 48, marginBottom: 16 }}></div> <div style={{ fontSize: 20, fontWeight: 700, color: T.tekst, marginBottom: 12 }}>Adgang ikke mulig</div> <div style={{ fontSize: 15, color: T.subtil, lineHeight: 1.6, marginBottom: 24 }}>{fejl}</div> <div style={{ fontSize: 14, color: T.subtil }}>Kontakt SkilsmisseVejen pa <a href="mailto:info@skilsmissevejen.dk" style={{ color: T.primaer }}>info@skilsmissevejen.dk</a></div> </div> </div>
 );
 const FANER = [
 { id: "overblik", label: "Overblik", ikon: "" },
 { id: "tidslinje", label: "Aktivitet", ikon: "" },
 { id: "dokumenter", label: "Dokumenter", ikon: "" },
 { id: "besked", label: "Besked", ikon: "" },
 ];
 return (
 <div style={{ minHeight: "100vh", background: T.bg, fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif" }}> <div style={{ background: T.primaer, padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}> <div style={{ color: "#fff" }}> <div style={{ fontSize: 18, fontWeight: 700 }}>SkilsmisseVejen</div> <div style={{ fontSize: 12, opacity: 0.85, marginTop: 2 }}>Min sag</div> </div>
 {sag && sag.sagsnummer && (
 <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: 8, padding: "6px 12px" }}> <div style={{ fontSize: 12, color: "rgba(255,255,255,0.8)" }}>Sagsnummer</div> <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>{sag.sagsnummer}</div> </div>
 )}
 </div> <div style={{ background: T.kort, borderBottom: "1px solid " + T.kant, display: "flex", overflowX: "auto" }}>
 {FANER.map(function(f) { return (
 <button key={f.id} onClick={function() { setFane(f.id); }}
 style={{ flex: 1, minWidth: 80, padding: "14px 8px", border: "none", background: "none", cursor: "pointer",
 borderBottom: fane === f.id ? ("3px solid " + T.primaer) : "3px solid transparent",
 color: fane === f.id ? T.primaer : T.subtil, fontWeight: fane === f.id ? 700 : 500, fontSize: 13,
 display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}> <span style={{ fontSize: 18 }}>{f.ikon}</span> <span>{f.label}</span> </button>
 ); })}
 </div> <div style={{ maxWidth: 720, margin: "0 auto", padding: "20px 16px 40px" }}>
 {fane === "overblik" && (<><SagKort sag={sag} /><ForloebTrin fase={sag && sag.fase} /></>)}
 {fane === "tidslinje" && <Tidslinje haendelser={haendelser} />}
 {fane === "dokumenter" && <Dokumenter dokumenter={dokumenter} />}
 {fane === "besked" && <SendBesked token={token} />}
 </div> <div style={{ textAlign: "center", padding: "20px 16px", borderTop: "1px solid " + T.kant, background: T.kort }}> <div style={{ fontSize: 12, color: T.subtil }}>SkilsmisseVejen · Din trygge vej igennem</div> </div> </div>
 );
}